'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _helpers = require('./helpers');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (handlers) {
  return Object.keys(handlers).reduce(function (result, actionType) {
    if ((0, _helpers.isOtherType)(actionType)) return result;

    var actionName = (0, _helpers.getActionName)(actionType);
    var action = function action() {
      var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends({
        type: actionType
      }, payload);
    };

    action.actionType = actionType;

    return _extends({}, result, _defineProperty({}, actionName, action));
  }, {});
};